var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnTimeGuarantee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M13 0c7.176.008 12.992 5.824 13 13 0 7.18-5.82 13-13 13S0 20.18 0 13 5.82 0 13 0zm0 2.167C7.017 2.167 2.167 7.017 2.167 13c0 5.983 4.85 10.833 10.833 10.833C18.98 23.827 23.827 18.98 23.833 13c0-5.983-4.85-10.833-10.833-10.833zM13 19.5a1.354 1.354 0 110 2.708 1.354 1.354 0 010-2.708zm-7.854-7.854a1.354 1.354 0 110 2.708 1.354 1.354 0 010-2.708zm3.851-2.649a1.083 1.083 0 011.519-.013l2.932 2.932h7.135a1.083 1.083 0 110 2.166H13c-.287 0-.563-.113-.766-.316l-3.25-3.25c-.41-.425-.405-1.1.013-1.519zM13 3.793A1.354 1.354 0 1113 6.5a1.354 1.354 0 010-2.708z"
  })));
}
export default SvgOnTimeGuarantee;